module.exports = __webpack_public_path__ + "img/season-2.0f66e9cf.png";